export function isElementInViewport(
  rect: { top: number; bottom: number },
  viewportHeight: number,
): boolean {
  return rect.bottom > 0 && rect.top < viewportHeight;
}

/**
 * Scroll-reveal should never hide copy from crawlers or headless clients
 * that report a 0x0 viewport. Those environments would otherwise keep every
 * `.marketing-reveal` node at opacity 0 and look like a soft 404.
 */
export function shouldDeferRevealAnimation(
  rect: { top: number; bottom: number },
  viewportHeight: number,
): boolean {
  if (!Number.isFinite(viewportHeight) || viewportHeight <= 0) {
    return false;
  }

  return !isElementInViewport(rect, viewportHeight);
}
